<section class="custom-toaster">
  <h1>
    <span class="nickname">{{ toast.data.nickname }}</span>
    {{ message }}
  </h1>
  <youtube-thumbnail
    [isDesktop]="false"
    [video]="toast.data"></youtube-thumbnail>
</section>
